export const GET_USER_TIMESLOTS = 'app/store/timeslot/GET_USER_TIMESLOTS';
export const GET_USER_TIMESLOTS_SUCCESS = 'app/store/timeslot/GET_USER_TIMESLOTS_SUCCESS';
export const GET_USER_TIMESLOTS_ERROR = 'app/store/timeslot/GET_USER_TIMESLOTS_ERROR';
